export default {
	props: {
		id: {
			type: Number,
			default: null
		},
	},
	data() {
		return {
		}
	},
	methods: {
		loadResource() {
            console.log("Form.methods.loadResource", this.id);
			if(this.id) {
				this.$store.commit('form/clear');

				this.fetchResource(this.id).then(response => {
					this.$store.commit('form/setId', response.id);

					if(response.completedStep) {
						this.$store.commit('form/setCompletedStep', response.completedStep);
					}

					this.$store.commit('form/mergeFormData', this.sanitizeResource(response));
				}).catch(error => console.error(error));
			} else {
				this.$store.commit('form/clear');
			}
		},
		fetchResource(id) {
			return Promise.reject('Not implemented');
		},
		sanitizeResource(response) {
			return response;
		}
	},
	created() {
		this.loadResource();
	}
}
